import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styles from "./styles.module.scss";
const BlackFridayCopy = ({ code, copy }) => (_jsxs("span", { className: styles.promo, children: [copy, "\u00A0", code && (_jsxs("span", { children: ["WITH CODE:\u00A0", _jsx("u", { children: code })] }))] }));
const BlackFridayBanner = ({ className, data }) => {
    if (data.copy !== "") {
        return (_jsxs("div", { className: `${className} ${styles.banner}`, children: [_jsx("div", {}), _jsx("div", { className: styles.copy, children: _jsx(BlackFridayCopy, { ...data }) })] }));
    }
    return null;
};
export default BlackFridayBanner;
